// Site navigation. Game lists here drive the desktop mega-menu and the mobile menu.
export const NAV_GROUPS = [
  {
    title: 'Logic puzzles',
    all: { label: 'All logic games', to: '/logic-games' },
    wide: true,
    links: [
      { label: 'Aquarium', to: '/games/aquarium' },
      { label: 'Binary Sudoku+', to: '/games/binary-sudoku-plus' },
      { label: 'Color Flood', to: '/games/palette-path' },
      { label: 'Crowns', to: '/games/crowns' },
      { label: 'Cryptograms', to: '/games/cryptograms' },
      { label: 'Daily Logic Puzzles', to: '/games/daily-logic-puzzles' },
      { label: 'Dominosa', to: '/games/dominosa' },
      { label: 'Dot Stream', to: '/games/dot-stream' },
      { label: 'Futoshiki', to: '/games/futoshiki' },
      { label: 'Galaxies', to: '/games/galaxies' },
      { label: 'Calcudoku', to: '/games/calcudoku' },
      { label: 'Kurodoku', to: '/games/kurodoku' },
      { label: 'LITS', to: '/games/lits' },
      { label: 'Logic Grid Puzzles', to: '/games/logic-grid-puzzles' },
      { label: 'Mine Finder', to: '/games/mine-finder' },
      { label: 'Mosaic', to: '/games/mosaic' },
      { label: 'Nonograms', to: '/games/nonograms' },
      { label: 'NoriNori', to: '/games/norinori' },
      { label: 'Pipes', to: '/games/pipes' },
      { label: 'Rectangles', to: '/games/rectangles' },
      { label: 'Renzoku', to: '/games/renzoku' },
      { label: 'Skyscrapers', to: '/games/skyscrapers' },
      { label: 'Slant', to: '/games/slant' },
      { label: 'Sudoku', to: '/games/sudoku' },
      { label: 'Thermometers', to: '/games/thermometers' },
      { label: 'Yin-Yang', to: '/games/yin-yang' },
    ],
  },
  {
    title: 'Word games',
    all: { label: 'All word games', to: '/word-games' },
    links: [
      { label: 'Final Phrase', to: '/games/final-phrase' },
      { label: 'Medieval Word Twister', to: '/games/medieval-word-twister' },
      { label: 'Word Wheel', to: '/games/word-wheel' },
    ],
  },
  {
    title: 'Card games',
    all: { label: 'All card games', to: '/card-games' },
    links: [
      { label: 'Euchre', to: '/games/euchre' },
      { label: 'Solitaire Pro Collection', to: '/games/solitaire-pro-collection' },
    ],
  },
  {
    title: 'Printable',
    all: { label: 'All printable puzzles', to: '/printable' },
    links: [
      { label: "This week's puzzle pack", to: '/printable/weekly' },
      { label: 'Logic grid puzzles', to: '/printable/logic-grid-puzzles' },
      { label: 'Crowns', to: '/printable/crowns' },
      { label: 'Binary Sudoku', to: '/printable/binary-sudoku-plus' },
      { label: 'Aquarium', to: '/printable/aquarium' },
      { label: 'Sudoku', to: '/printable/sudoku' },
      { label: 'Tent Logic', to: '/printable/tent-logic' },
      { label: 'Nonograms', to: '/printable/nonograms' },
      { label: 'Calcudoku', to: '/printable/calcudoku' },
    ],
  },
];

export const NAV_LINKS = [
  { label: 'Apps', to: '/apps' },
  { label: 'Blog', to: '/blog' },
  { label: 'About', to: '/about' },
];
